// src/components/ProductHuntBanner.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';

export default function ProductHuntBanner() {
  return (
    <Box
      component="a"
      href="https://www.producthunt.com/products/openjam?launch=openjam"
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        backgroundImage: 'linear-gradient(45deg, #3f51b5,rgb(233, 119, 25),rgb(181, 63, 155))',
        backgroundSize: '200% 200%',
        animation: 'bgShift 8s ease-in-out infinite',
        '@keyframes bgShift': {
          '0%':   { backgroundPosition: '0% 50%' },
          '50%':  { backgroundPosition: '100% 50%' },
          '100%': { backgroundPosition: '0% 50%' },
        },
        color:            '#fff',
        px:               2,
        py:               1,
        display:          'flex',
        alignItems:       'center',
        justifyContent:   'center',
        position:         'relative',
        overflow:         'hidden',
        minHeight:        '40px',
        textDecoration:   'none',
        '@keyframes float': {
          '0%':   { transform: 'translateY(0px)' },
          '50%':  { transform: 'translateY(-6px)' },
          '100%': { transform: 'translateY(0px)' },
        },
      }}
    >
      {/* Left confetti emoji */}
      <Typography
        component="span"
        sx={{
          fontSize:  '1.5rem',
          mr:        1.5,
          animation: 'float 3s ease-in-out infinite',
        }}
      >
        🎉
      </Typography>

      {/* Main text */}
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 600,
          fontSize:   '1rem',
          textAlign:  'center',
        }}
      >
        We’re live on{' '}
        <Box
          component="span"
          sx={{
            textDecoration: 'underline',
            '&:hover': { opacity: 0.8 },
          }}
        >
          Product Hunt
        </Box>
        {' '}right now!
      </Typography>

      {/* Right confetti emoji */}
      <Typography
        component="span"
        sx={{
          fontSize:       '1.5rem',
          ml:             1.5,
          animation:      'float 3s ease-in-out infinite',
          animationDelay: '1s',
        }}
      >
        🎉
      </Typography>
      
    </Box>
  );
}
